import LoginPage from 'views/Pages/LoginPage.jsx';


var pagesRoutes = [
    { path: "/pages/login-page", name: "Login Page", mini: "LP", component: LoginPage },
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx